import { pipe, prop } from 'ramda';

import { journeysSelector } from '../selectors';

// eslint-disable-next-line import/prefer-default-export
export const activeJourneyModalSelector = pipe(
  journeysSelector,
  prop('activeJourneyModal')
);
